import React, { Component } from 'react';
import '../myutils';
import {
    translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book';
import ContentCut from '@material-ui/icons/ContentCut';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

export const TemplateIcon = BookIcon;

class CutFile extends Component {

    state = {
        open: false,
      };
      constructor(props) {
        super(props);
        this.state = {
          record: false
        }
      }

      handleClickCut = (e,record) => {
        e.stopPropagation();
        sessionStorage.setItem('action', 'move')

        if (record) {

            sessionStorage.setItem('copiedFile', record.what)
            this.props.handleCloseMenu();
        }
        else {
            sessionStorage.setItem('copiedFile', sessionStorage.selectedFile)
        }
      };

      render() {
        const { translate, record } = this.props;
        return (
            <Tooltip title={translate(`trans.cut`)}>
                <IconButton onClick={(e)=>this.handleClickCut(e,record)} > 
                <ContentCut/>
                </IconButton>
            </Tooltip>
            );
    }
}

export default translate(CutFile);
